import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { FormArray, UntypedFormGroup } from '@angular/forms';
import { ControlValueAccessor,NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormGroup,FormControl } from '@angular/forms';
import { QueryEditorService } from 'src/app/language-service/query-editor.service';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { StructureTagService } from 'src/app/services/structureTag.service';
import { QueryTokensProviderService } from 'src/app/language-service/query-tokens-provider.service';
import { ToastService } from '../custom-overlay/toast/toast.service';
import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ExplorelogsService } from 'src/app/explore-logs/explorelogs.service';
import { AbstractControl } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


@Component({
  selector: 'app-auto-closure',
  templateUrl: './auto-closure.component.html',
  styleUrls: ['./auto-closure.component.scss']
})



export class AutoClosureComponent {
  constructor(public router:Router,public alertvarservice:AlertsvarService,public alertservice:AlertsService,
    public queryEditorService:QueryEditorService,
    private rcrumpService:RoutecrumpsService,
    private structureTags: StructureTagService,
    private querytokenprovider:QueryTokensProviderService,
    private toasterService:ToastService){
  }

  alertId;
  form: FormGroup = new FormGroup({
    closureAction: new FormControl('')
  });
  selectedIndex=0;
  description:string=''
  platform:string=''
  ruleType:string=''
  alertName:string=''
  mat_spinner_create_state:boolean = false;
  routeBack:Subject<null> = new Subject();
  $destroy:Subject<boolean> = new Subject();
  destroyed$: Subject<boolean> = new Subject();
  queryCheck=["1"]
  current_index=0
  previous_index=0
  timeframevalue:any=3600
  stepsizevalue:any=3600
  valuerange:any
  min:number
  max:number
  step:any[]
  errstr=""

  ngOnInit(){
    

    Object.keys(this.alertvarservice.updateActionMetadata.actions).forEach(element => {
      this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]=JSON.parse(JSON.stringify(this.alertvarservice.updateActionMetadata.actions[element]))
      
      Object.keys(this.alertvarservice.updateActionMetadata.actions[element]["state_action"]).forEach(val=>{
        this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]["state_action"][this.alertvarservice.updateActionMetadata.actions[element]["state_action"][val]["id"]]=JSON.parse(JSON.stringify(this.alertvarservice.updateActionMetadata.actions[element]["state_action"][val]))
        this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]["state_action"][this.alertvarservice.updateActionMetadata.actions[element]["state_action"][val]["id"]]["disp"]=val
        delete this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]["state_action"][val]
        // this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value][val]=this.alertvarservice.updateActionMetadata.actions[element][val]
      })
      this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]["state"]=0
      this.alertvarservice.closureAction1[this.alertvarservice.updateActionMetadata.actions[element].value]["enable"]=true
    });
//console.log("Meta--->",this.alertvarservice.closureAction1,"\n",this.alertvarservice.updateActionMetadata.actions)
//console.log("EditState",this.alertvarservice.editState)
   
    
   
    // this.ruleName.setValue("Description")
   

    if(this.alertvarservice.editState){
      this.rcrumpService.route_crumps [2] = {
        disp_str:"Edit",
        routeTo:"auto-closure",
        callback:null,
        isParent:false
      }
    }
    else{
      this.rcrumpService.route_crumps [3] = {
        disp_str:"Auto Closure",
        routeTo:"auto-closure",
        callback:this.routeBack,
        isParent:false
      }
    }
    this.routeBack.subscribe(()=>{
      this.crumpsBackClick()
    })


    if(this.alertvarservice.editState){
     
      // console.log("editrequested",this.alertvarservice.editrequested.value)
      // this.conditions.setValue(this.alertvarservice.editrequested.value.conditions)
      // this.alertvarservice.autoInvestigate.patchValue({
      //   conditions:this.alertvarservice.editrequested.value.conditions
      // })
      // console.log("Edit",this.conditions)
      setTimeout(() => {
        this.timeframe.setValue(this.alertvarservice.editrequested.value.timeframe)
        
      }, 100);
      setTimeout(() => {
        this.stepsize.setValue(this.alertvarservice.editrequested.value.stepsize)
      }, 200);

      this.alertId=this.alertvarservice.editrequested.value.ruleFor
//console.log("Alert Id",this.alertId)
      
      this.conditions.clear()
      Object.keys(this.alertvarservice.editrequested.value.conditions).forEach(i => {
        // console.log("conditions>>>>>>>>",this.alertvarservice.editrequested.value.conditions[i])
        this.pushForm(parseInt(i))
        this.conditions.controls[i].setValue(this.alertvarservice.editrequested.value.conditions[i])
        // this.conditionClick[i]
        // this.conditionClick(0)
      });
//console.log("Auto Investigate--------->",this.alertvarservice.autoInvestigate.value)
      // this.conditionClick(0)
      this.editset(0)
      setTimeout(()=>{
        this.conditionClick(0)
       },1500);
      // this.conditionClick[0]
//console.log("Edit",this.conditions)
    }
    else{
      this.timeframe.setValue(3600)
      this.stepsize.setValue(3600)
    }

    


  
    
 
   

    // this.alertvarservice.$alertName.subscribe(value => {
    //   console.log('AlertName>>>>>>>>>', value);
    //   this.alertId=value
    //   this.alertservice.alertRules.context.rule_id=this.alertId
    // });
    // this.alertvarservice.$platform.subscribe(value => {
    //   console.log('platform>>>>>>>>>', value);
    //   this.platform=value
    //   // this.alertservice.alertRules.context.rule_id=this.alertId
    // });
    this.alertvarservice.$ruleGroup.subscribe(value => {
//console.log('ruleType>>>>>>>>>', value);
      this.ruleType=value
      // this.alertservice.alertRules.context.rule_id=this.alertId
    });
//console.log("Edit State",this.alertvarservice.editState)
    
    if(this.alertvarservice.editState){
      this.ruleName.setValue(this.alertvarservice.editrequested.value.description)
      this.alertId=this.alertvarservice.editrequested.value.ruleFor
//console.log("Alert Id",this.alertId)
      this.alertName=this.alertvarservice.editrequested.value.name
    }
    else{
      this.alertvarservice.$alert.subscribe(value => {
//console.log('alert>>>>>>>>>', value);
        this.alertId=value["alertId"]
        this.platform=value["platform"]
        this.alertName=value["alertTitle"]
      });
    }
    if(this.alertvarservice.editState){
      setTimeout(() => {
        this.ruleName.setValue(this.alertvarservice.editrequested.value.description)
      }, 0);
      
      this.activate.setValue(this.alertvarservice.editrequested.value.activate_rule)
      this.retroactive.setValue(this.alertvarservice.editrequested.value.retroactive)
//console.log("Description-->",this.ruleName.value,"\n",this.alertvarservice.editrequested.value.description)
    }
    else{
      this.activate.setValue(true)
      this.retroactive.setValue(false)
      
    }
  }

  ngAfterViewInit(){
    this.timeframe.valueChanges.subscribe((data)=>{
//console.log("<---------Timeframe value changes-------->")
      this.timeframevalue=data
      // this.timeEmit=data
      // this.action=this.alertvarservice.ruleForm.value.actions.actionname
      // this.reasonstate=this.alertvarservice.ruleForm.value.actions.closurestate.statename
      // this.reason=this.alertvarservice.ruleForm.value.actions.closurestate.closurereason
      // this.commentStr=this.alertvarservice.ruleForm.value.actions.comments
      
      // console.log(this.rulevarservice.timeframe)
      // console.log(this.rulevarservice.timeframe[0].range[0].min)
      if(this.timeframevalue < this.stepsizevalue){
//console.log("ErrorType",this.alertvarservice.errorState[1])
//console.log(this.alertvarservice.errorType[102])
        this.errstr=this.alertvarservice.errorType[102]
        // this.rulevarservice.isInvalid=true
        this.alertvarservice.errorState[1] = true;
        this.alertvarservice.timeError=true
//console.log("ErrorType",this.alertvarservice.errorState[1])
      }
      else{
        this.alertvarservice.errorState[1] = false;
        this.alertvarservice.timeError=false
      }
      this.valuerange = this.alertvarservice.timeframe.find(list => list.value === this.timeframevalue);
//console.log("Range",this.valuerange?.range[0]); 
      this.min=this.valuerange?.range[0]?.min
      this.max=this.valuerange?.range[0]?.max
      // this.rulevarservice.stepsize=this.rulevarservice.timeframe
//console.log("Step---->",typeof(this.step))
      // this.step[0]
      this.step=[]
      Object.values(this.alertvarservice.stepsize1).forEach(value => {
        if(value.value>=this.min && value.value<=this.max)
          // console.log(value)
          this.step.push(value)
      });
      this.alertvarservice.stepsize=this.step
//console.log(this.alertvarservice.stepsize)

      

    })
    this.stepsize.valueChanges.subscribe((data)=>{
      this.stepsizevalue=data
      

      if(this.timeframevalue < this.stepsizevalue){
//console.log("ErrorType",this.alertvarservice.errorState[1])
//console.log(this.alertvarservice.errorType[102])
        this.errstr=this.alertvarservice.errorType[102]
        // this.rulevarservice.isInvalid=true
        this.alertvarservice.errorState[1] = true;
        this.alertvarservice.timeError=true
//console.log("ErrorType",this.alertvarservice.errorState[1])
      }
      else{
        this.alertvarservice.errorState[1] = false;
        this.alertvarservice.timeError=false
        this.errstr=""
      }
     
      
    })
    this.ruleName.valueChanges.subscribe((data)=>{
      // console.log("Rule Description>>>>>>>>",data)
      this.description=data
      // this.alertservice.alertRules.context.description=data
    })
    this.form.get('closureAction').valueChanges.subscribe(value => {
      // console.log('Value changed in child:',this.selectedIndex,">>>>>>", value);
      this.conditions.at(this.selectedIndex).patchValue({
        actions:JSON.parse(JSON.stringify(value))
      })
    });
  }

  get context() {
    return this.alertvarservice.ruleForm.get('context') as UntypedFormGroup
  }

  get ruleName(){
    return this.context.get('ruleName')
  }
  get activate(){
    return this.context.get('activate')
  }
  get retroactive(){
    return this.context.get('retroactive')
  }
  get timeframe(){
    return this.context.get("timeframe")
  }
  get stepsize(){
    return this.context.get("stepsize")
  }

  get conditions(){
    return this.alertvarservice.autoInvestigate.get('conditions') as FormArray
    
  }
  actions(){
    return this.conditions.get('actions')
  }

  pushForm(i:number){

    

    if(this.conditions.length<this.alertvarservice.auto_investigate_limit){
        this.conditions.insert(i+1,this.alertvarservice.addNewCond(),{emitEvent:false});
      // console.log(this.alertvarservice.autoInvestigate)
      if(!this.alertvarservice.editState){
        // this.conditionClick(i+1)
      }
    }
  }

  postSatusChange(status: any) {
    if (status) {
      return 1
    } else {
      return 0
    }
  }

  editset(i:number){

    let query =""


    this.alertvarservice.resetRuleForm(),{emitEvent:false}
    this.alertvarservice.resetTags(),{emitEvent:false}
    if(this.alertvarservice.autoInvestigate.value.conditions[i].actions){
      this.alertvarservice.clickedAction=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
      this.alertvarservice.clickedState=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state
      this.alertvarservice.clickedReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.category
      this.alertvarservice.clickedStateReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
      if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason){
        this.alertvarservice.openComments=false
        this.alertvarservice.ruleForm.controls.comments.setValue('')
      }
      else{
        this.alertvarservice.openComments=true
      }
      this.alertvarservice.ruleForm.patchValue({
        query:this.alertvarservice.autoInvestigate.value.conditions[i].actions?.query,
        comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
        actions:{
          actionname:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action,
          closurestate:{
            statename:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state,
            closurereason:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
          },
          // comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
          add_tags:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.add_tags,
          
        }
      },{emitEvent:false})
      // console.log("After RuleForm Patch",this.alertvarservice.ruleForm.value.actions.add_tags)
    }
    if(this.alertvarservice.autoInvestigate.value.conditions[i].actions?.state){
      // this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
    }

    // this.queryEditorService.lintChanges$.subscribe(() => {
    //   console.log("Lint Changes Emitted", this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
    //   console.log("Editor get",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor),this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
    //     console.log("Before Set Validation-->",i,this.conditions.get(i.toString()).get("actions"))
    //     this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
    //     this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });


    //     console.log("Current Index After Validation-->",i,this.conditions.get(i.toString()).get("actions"))
    //     this.alertvarservice.process_state=false
    //     console.log(this.alertvarservice.process_state)
    // })

    // if(this.alertvarservice.autoInvestigate.value.conditions[i].actions){
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,this.alertvarservice.autoInvestigate.value.conditions[i].actions.query),{emitEvent:false}
    // }
    // else{
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,query),{emitEvent:false}
    // }
  }

  removeForm(i:number){
    if(i!=0){
      this.conditions.removeAt(i)
//console.log("Remove Index--->",i)
      setTimeout(() => {
        this.conditionClick(i)
      }, 0);
      
    }
  }


  enableGroupValidation() {
    this.form.get('credentials')!.setValidators(this.alertvarservice.queryValidator);
    this.form.get('credentials')!.updateValueAndValidity({ emitEvent: false });
  }
  
  disableGroupValidation() {
    this.form.get('credentials')!.clearValidators();
    this.form.get('credentials')!.updateValueAndValidity({ emitEvent: false });
  }




 conditionClick(i:number){


  // setTimeout(() => {
  //   console.log("Engine Query====---->",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[i],this.querytokenprovider.parseTokens(this.alertvarservice.ruleConditionEditor).searchTokens))

  // }, 2000);
    
    this.selectedIndex=i
   
    let query=""

    // console.log("Current Index Validation-->",i,this.conditions.get(i.toString()).get("actions").valid)
    // this.alertvarservice.resetRuleForm(),{emitEvent:false}
    // this.alertvarservice.resetTags(),{emitEvent:false}

    // console.log(this.conditions.get(i.toString()).get("actions"))
    // console.log(this.conditions.value.length-1,i)
    // if(i!=this.conditions.value.length-1){
      if(this.current_index!=i){
        this.alertvarservice.process_state=true
        this.previous_index=this.current_index
        this.current_index=i
        let prevStatus 
        let prevErrors 
        if(this.conditions.get(this.previous_index.toString())){
          prevStatus = this.conditions.get(this.previous_index.toString()).get("actions").status;
          prevErrors = this.conditions.get(this.previous_index.toString()).get("actions").errors;
        }

        // if(prevStatus){
        //   this.conditions.get(this.previous_index.toString()).get("actions").value.engineQuery?.setValue(this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[this.previous_index],this.querytokenprovider.parseTokens(this.alertvarservice.ruleConditionEditor).searchTokens))
        //   console.log("Engine Query Set------>",this.alertvarservice.autoInvestigate)
        // }
        
        // console.log("Inside Validators ")
        // console.log("Current Index Before SetErrors-->",i,this.conditions.get(i.toString()).get("actions").valid)

        // setTimeout(() => {

        // Remove validators for previous index
          // console.log("Prev Index Before setErrors-->",this.previous_index,prevStatus,"\n",prevErrors,"\n",this.conditions.get(this.previous_index.toString()).get("actions").valid)
          if(this.conditions.get(this.previous_index.toString())){
            this.conditions.get(this.previous_index.toString()).get("actions")!.clearValidators(),{emitEvent:false};
            this.conditions.get(this.previous_index.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });
          

          if (prevStatus === 'INVALID') {
            // console.log("Invalid For Previous============")
            this.conditions.get(this.previous_index.toString()).get("actions").setErrors(prevErrors)
          }
          }
          let description=this.ruleName.value
          
          this.alertvarservice.resetRuleForm(),{emitEvent:false}
          this.ruleName.setValue(description)
          this.alertvarservice.resetTags(),{emitEvent:false}
          if(this.alertvarservice.autoInvestigate.value.conditions[i] && this.alertvarservice.autoInvestigate.value.conditions[i].actions){
            this.alertvarservice.ruleForm.patchValue({
              query:this.alertvarservice.autoInvestigate.value.conditions[i].actions?.query,
              comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
              actions:{
                actionname:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action,
                closurestate:{
                  statename:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state,
                  closurereason:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
                },
                // comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
                add_tags:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.add_tags,
                
              }
            },{emitEvent:false})
            // console.log("After RuleForm Patch",this.alertvarservice.ruleForm.value.actions.add_tags)
          }
          else{

            this.alertvarservice.clickedAction=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
            this.alertvarservice.clickedState=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state
            this.alertvarservice.clickedReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.category
            this.alertvarservice.clickedStateReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
            // console.log("Query 1.7 ---> ",this.conditions.value[i].actions)

          }
          if(this.alertvarservice.autoInvestigate.value.conditions[i] && this.alertvarservice.autoInvestigate.value.conditions[i].actions && this.alertvarservice.autoInvestigate.value.conditions[i].actions?.value){
            this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
          }

          // this.queryEditorService.lintChanges$.subscribe(() => {
          //   console.log("Lint Changes Emitted", this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
          //   console.log("Editor get",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor),this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
          //     console.log("Before Set Validation-->",i,this.conditions.get(i.toString()).get("actions"))
          //     this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
          //     this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });


          //     console.log("Current Index After Validation-->",i,this.conditions.get(i.toString()).get("actions"))
          //     this.alertvarservice.process_state=false
          //     console.log(this.alertvarservice.process_state)
          // })

          if(this.alertvarservice.autoInvestigate.value.conditions[i] && this.alertvarservice.autoInvestigate.value.conditions[i].actions){
            this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,this.alertvarservice.autoInvestigate.value.conditions[i].actions.query),{emitEvent:false}
          }
          else{
            this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,query),{emitEvent:false}
          }
          if(this.alertvarservice.autoInvestigate.value.conditions[i] && this.alertvarservice.autoInvestigate.value.conditions[i].actions){

            this.alertvarservice.clickedAction=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
            this.alertvarservice.clickedState=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state
            this.alertvarservice.clickedReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.category
            this.alertvarservice.clickedStateReason=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
            // console.log("Query 1.5.2.1 ---> ",this.conditions.value[i].actions)
            if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason){
              // console.log("Query 1.5.2.2 ---> ",this.conditions.value[i].actions)
              this.alertvarservice.openComments=false
              // console.log("Query 1.5.2.3 ---> ",this.conditions.value[i].actions)
              this.alertvarservice.ruleForm.controls.comments.setValue(''),{emitEvent:false}
              // console.log("Query 1.5.3 ---> ",this.conditions.value[i].actions)
            }
            else{
              this.alertvarservice.openComments=true
              // console.log("Query 1.5.4 ---> ",this.conditions.value[i].actions)
            }
          }

          // console.log("After SetErrors-->",this.previous_index,this.conditions.get(this.previous_index.toString()).get("actions").valid)
//console.log("Process State -->",this.alertvarservice.process_state)

          

          setTimeout(() => { // Set Validators for current index if not else
            if(i!=this.conditions.value.length-1){
              // console.log("Editor get",this.queryEditorService.get_editor_value(this.alertvarservice.ruleConditionEditor),this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
              // console.log("Before Set Validation-->",i,this.conditions.get(i.toString()).get("actions"))
              this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
              this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });
            }
            else if(this.conditions.get(i.toString()).get("actions").value?.query?.length>0){ // Set validators for else,if query is not empty
              this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
              this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });
            }
            else{ // Remove validators for else , if query is empty
              this.conditions.get(i.toString()).get("actions")!.clearValidators(),{emitEvent:false};
              this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });
            }
              // console.log("Current Index After Validation-->",i,this.conditions.get(i.toString()).get("actions"))
              this.alertvarservice.process_state=false
//console.log(this.alertvarservice.process_state)
          }, 1500);
        

        // }, 0);

      // this.conditions.get(i.toString()).get("actions")!.setValidators(this.alertvarservice.queryValidator),{emitEvent:false};
      // this.conditions.get(i.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });

      // this.conditions.get(this.previous_index.toString()).get("actions")!.clearValidators(),{emitEvent:false};
      // this.conditions.get(this.previous_index.toString()).get("actions")!.updateValueAndValidity({ emitEvent: false });

    
     

  

      // if(this.conditions.get(this.previous_index.toString()).get("actions").valid){
      //   console.log("Last Control is Valid",this.conditions.get(this.previous_index.toString()).get("actions").valid)
      // }
      // else{
      //   console.log("Last control is not Valid",this.conditions.get(this.previous_index.toString()).get("actions").valid)
      // }

      // if(this.conditions.get(this.current_index.toString()).get("actions").valid){
      //   console.log("Current Control is Valid",this.conditions.get(this.current_index.toString()).get("actions").valid)
      // }
      // else{
      //   console.log("Current Control is not valid",this.conditions.get(this.current_index.toString()).get("actions").valid)
      // }
    }
  // }
    
    // this.alertvarservice.resetRuleForm()
    // console.log(this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor))
    this.alertvarservice.showError=false
    Object.keys(this.alertvarservice.closureAction1).forEach(data=>{
      this.alertvarservice.closureAction1[data].state=0
    })
    // this.alertvarservice.closureAction1.flagged_for_review.state=0
    // this.alertvarservice.closureAction1.close.state=0

    // this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
    // this.alertvarservice.closureAction.no_action_required.state = 0
    // if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action==="flagged_for_review"){
    //   // this.alertvarservice.closureAction1.flagged_for_review.state=1
    //   this.alertvarservice.closureAction.no_action_required.state = 0
    // }
    // if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action==="close"){
    //   // this.alertvarservice.closureAction1.close.state=1
    //   this.alertvarservice.closureAction.no_action_required.state = 0
    // }
    if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action==="no_action_required"){
        // this.alertvarservice.closureAction1.close.state=0
        // this.alertvarservice.closureAction.no_action_required.state = 1
        // this.alertvarservice.closureAction1.flagged_for_review.state=0
        Object.keys(this.alertvarservice.closureAction1).forEach(data=>{
          this.alertvarservice.closureAction1[data].state=0
        })
    }
    else{
      if(this.alertvarservice.autoInvestigate.value.conditions[i] && this.alertvarservice.autoInvestigate.value.conditions[i].actions && this.alertvarservice.autoInvestigate.value.conditions[i].actions.action){
        // console.log("==================>",this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action)
        // console.log("----------------->",this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action])
        // this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
      }
      // Object.keys(this.alertvarservice.closureAction1).forEach(data=>{
      //   this.alertvarservice.closureAction1[data].state=0
      // })
      // this.alertvarservice.closureAction.no_action_required.state = 0
    }




    if(this.alertvarservice.editState){
      // if(this.alertvarservice.editrequested.value.conditions[i]?.actions?.action==="flagged_for_review"){
      //   this.alertvarservice.closureAction1.flagged_for_review.state=1
      //   this.alertvarservice.closureAction.no_action_required.state = 0
      // }
      // else if(this.alertvarservice.editrequested.value.conditions[i]?.actions?.action==="close"){
      //   this.alertvarservice.closureAction1.close.state=1
      //   this.alertvarservice.closureAction.no_action_required.state = 0
      // }
      // else 
      if(this.alertvarservice.editrequested.value.conditions[i]?.actions?.action==="no_action_required"){
        // this.alertvarservice.closureAction1.close.state=0
        // this.alertvarservice.closureAction.no_action_required.state = 1
        Object.keys(this.alertvarservice.closureAction1).forEach(data=>{
          this.alertvarservice.closureAction1[data].state=0
        })
        // this.alertvarservice.closureAction1.flagged_for_review.state=0
      }
      
        else{
          if(this.alertvarservice.editrequested.value.conditions[i] && this.alertvarservice.editrequested.value.conditions[i].actions && this.alertvarservice.editrequested.value.conditions[i].actions.action){
            // this.alertvarservice.closureAction1[this.alertvarservice.editrequested.value.conditions[i]?.actions?.action].state=1
            // this.alertvarservice.closureAction.no_action_required.state = 0
          }
        }
      
  }
   


    // console.log("Conditions1",this.alertvarservice.autoInvestigate.value.conditions)
    // this.alertvarservice.resetRuleForm()
    // console.log("Dis Tag",this.alertvarservice.distag)
    // this.alertvarservice.ruleForm.patchValue({
    //   actions:{
    //     add_tags:{
    //       tags:this.structureTags.tagarrtoObj(this.structureTags.structureTagPost(this.alertvarservice.emptyTags))
    //     }
    //   }
    // })
    // console.log("Conditions2",this.alertvarservice.autoInvestigate.value.conditions)
    
    // console.log("selectedIndex",this.selectedIndex)
    
    // console.log("FormControl",this.alertvarservice.autoInvestigate.value.conditions[i])
    this.alertvarservice.actionWindow=''
    this.alertvarservice.stateWindow=''
    this.alertvarservice.actionWindow=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
    this.alertvarservice.stateWindow=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state
    // console.log("ActionWindow==>",i,this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action,this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state)
    // console.log("Conditions3",this.selectedIndex,this.alertvarservice.autoInvestigate.value.conditions)
    // console.log("Tags",this.structureTags.tagarrtoObj(this.structureTags.structureTagPost(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.tags)))
    // console.log("Auto Investigate statename",this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state)
    // console.log("Conditions3.5",this.alertvarservice.autoInvestigate.value.conditions[i])
  //   if(this.alertvarservice.autoInvestigate.value.conditions[i].actions){
  //   this.alertvarservice.ruleForm.patchValue({
  //     query:this.alertvarservice.autoInvestigate.value.conditions[i].actions?.query,
  //     actions:{
  //       actionname:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action,
  //       closurestate:{
  //         statename:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.state,
  //         closurereason:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason
  //       },
  //       comments:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.comments,
  //       add_tags:this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.add_tags,
        
  //     }
  //   },{emitEvent:false})
  //   console.log("After RuleForm Patch",this.alertvarservice.ruleForm.value.actions.add_tags)
  // }
  // if(this.alertvarservice.autoInvestigate.value.conditions[i].actions?.state){
  //   this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
  // }
  // this.alertvarservice.actionWindow=this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action
  // if(this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.reason){
  //   this.alertvarservice.closureAction1[this.alertvarservice.autoInvestigate.value.conditions[i]?.actions?.action].state=1
  // }
    // console.log("RuleForm",this.alertvarservice.ruleForm.value.actions.add_tags)
    // console.log("Conditions4",this.alertvarservice.autoInvestigate.value.conditions)
    // console.log("statename",this.alertvarservice.ruleForm)
    // console.log("Before Set Value",this.alertvarservice.ruleForm.controls.actions)
    // this.alertvarservice.ruleForm.patchValue({
    //   actions:{
    //     add_tags:this.alertvarservice.emptyTags
    //   }
    // })
   
    // console.log("After Set value",this.alertvarservice.ruleForm)
    // let actions = this.conditions.at(i) as FormGroup;
    // actions.patchValue({
    //   actions:this.alertvarservice.ruleForm
    // })
    // console.log(actions)
    // console.log(i,this.alertvarservice.autoInvestigate.value?.conditions[i])
   

    // this.alertvarservice.ruleForm.patchValue({
    //   query:this.alertvarservice.autoInvestigate.value.conditions[i].actions?.query
    // })
    // console.log(this.alertvarservice.ruleForm)

    // if(this.alertvarservice.autoInvestigate.value.conditions[i].actions){
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,this.alertvarservice.autoInvestigate.value.conditions[i].actions.query),{emitEvent:false}
    // }
    // else{
    //   this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,query),{emitEvent:false}
    // }
    // console.log("Conditions5",this.alertvarservice.autoInvestigate.value.conditions)
    
    // this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetTestResults(),{emitEvent:false}
    // console.log("Conditions6",this.alertvarservice.autoInvestigate.value.conditions)
    // this.alertvarservice.resetTags(),{emitEvent:false}
    // console.log("Conditions-->",this.alertvarservice.autoInvestigate.value.conditions)
    
    // console.log("RuleForm Final--->",this.alertvarservice.ruleForm)

  }
  checkAction(){
//console.log(this.alertvarservice.autoInvestigate)
    if(this.alertvarservice.autoInvestigate.valid){
//console.log("Auto Investigate is Valid")
    }
    else{
//console.log("Auto Investigate is not valid")
    }
  }
  cancelClick(){
//console.log("CancelClicked")
    this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetAutoInvestigate()
    if(this.alertvarservice.editState){
      this.router.navigateByUrl('/rule')
    }else{
      this.alertvarservice.resetRuleForm()
      this.alertvarservice.resetAutoInvestigate()
      this.router.navigateByUrl('/explorelogs')
      this.rcrumpService.route_crumps.length = 2;
    }
   
    
  }
  crumpsBackClick(){
    this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetAutoInvestigate()
    this.router.navigateByUrl('/explorelogs')
    this.rcrumpService.route_crumps.length = 2;
  }

  engineCheck(rulevalue:any){
  //  if(!this.alertvarservice.compareobjects(this.alertvarservice.editrequested.value,rulevalue)){
  //   return true
  //  }else{
  //   return false
  //  }
    if(this.alertvarservice.editrequested.value.retroactive != this.retroactive.value){
      return true
    }
    if(this.alertvarservice.editrequested.value.timeframe != this.timeframe.value){
      return true
    }
    if(this.alertvarservice.editrequested.value.stepsize != this.stepsize.value){
      return true
    }
    if(this.alertvarservice.editrequested.value.conditions.length != this.conditions.value.length){
      return true
    }
    else{
//console.log("Compare ArrofObj--->",this.alertvarservice.compareArrayOfObjects(this.alertvarservice.editrequested.value.conditions,rulevalue.conditions))
      if(!this.alertvarservice.compareArrayOfObjects(this.alertvarservice.editrequested.value.conditions,rulevalue.conditions)){
        return true
      }
      else{
        return false
      }
    }
  }

  async submitClicked(){

    if(!this.alertvarservice.timeError){
//console.log("VALID",this.alertvarservice.autoInvestigate.controls.conditions.valid)

      Object.keys(this.alertvarservice.autoInvestigate.controls.conditions.controls).forEach((key)=>{
//console.log(key,"Valid",this.alertvarservice.autoInvestigate.controls.conditions.controls[key].controls.actions)
      })

//console.log("RawValues",this.alertvarservice.autoInvestigate.getRawValue())

      Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key=>{
        // console.log("raw value",this.alertvarservice.autoInvestigate.getRawValue().conditions[key])
      // if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions?.condition!="else"){
      //   if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions?.state){
      //     this.alertvarservice.actionEmpty=false
      //     this.alertvarservice.showActionError=false
      //     console.log("Not Empty")
      //   }
      //   else{
      //     this.alertvarservice.actionEmpty=true
      //     this.alertvarservice.showActionError=true
      //     console.log("Is Empty")
      //     if(this.alertvarservice.ActionErrorText.length>0){
      //       this.alertvarservice.ActionErrorText=",",[key]
      //     }
      //     else{
      //       this.alertvarservice.ActionErrorText=key
      //     }
      //    }
      //   }
      })

      setTimeout(() => {
        if(this.queryEditorService.isEditorError(this.alertvarservice.ruleConditionEditor)){
          this.alertvarservice.queryVerified=false
        }
        else{
          this.alertvarservice.queryVerified=true
        }
        if(!this.alertvarservice.queryVerified){
          this.alertvarservice.showError=true
        }
        else{
          this.alertvarservice.showError=false
        }
      }, 1500);

      

//console.log(this.alertvarservice.autoInvestigate.getRawValue().conditions[0].actions)
      if(this.alertvarservice.autoInvestigate.getRawValue().conditions[0].actions){
        this.alertvarservice.postError=false
      }
      else{
        this.alertvarservice.postError=true
      }
    
        let postvalue = this.alertvarservice.autoInvestigate.getRawValue()
//console.log("length",String(postvalue.conditions.length-1))
        Object.keys(postvalue.conditions).forEach(key=>{
//console.log("Key",key)
    
        //   if(postvalue.conditions[key].actions?.add_tags){
        //     Object.keys(postvalue.conditions[key].actions?.add_tags?.tags).forEach(val=>{
        //       // console.log("Edit Tag",postvalue.conditions[key].actions.add_tags.tags)
        //       if(Object.keys(postvalue.conditions[key].actions.add_tags.tags[val]).length==0){ 
        //         console.log("empty",postvalue.conditions[key])
        //       }
        //     })
        // }
    
    
        if(this.alertvarservice.autoInvestigate.valid){
    
          if(key==="0"){
            postvalue.conditions[key].actions["condition"]="if"
//console.log("PostValue",postvalue)
          }
          else if(key === String(postvalue.conditions.length-1)){
            if(postvalue.conditions[key].actions){
              postvalue.conditions[key].actions["condition"]="else"
            }
            else{
              postvalue.conditions.splice(postvalue.conditions.length-1,1)
            }
          }
          else if(postvalue.conditions[key].actions){
            postvalue.conditions[key].actions["condition"]="else_if"
          }
        }
        else{
          this.alertvarservice.showActionError=true
        }
        })
        
        if(this.alertvarservice.editState){

          if(this.alertvarservice.editrequested.value.status_change != this.activate.value){
            this.alertvarservice.status_change=true
          }

          postvalue["platform"]=this.alertvarservice.editrequested.value.platform
          postvalue["name"]=this.alertvarservice.editrequested.value.name
          postvalue["type"]=this.alertvarservice.editrequested.value.type
          postvalue["ruleFor"]=this.alertvarservice.editrequested.value.ruleFor
          postvalue["description"]=this.ruleName.value
          postvalue["status"]=this.postSatusChange(this.activate.value)
          postvalue["enginechange"]=this.engineCheck(postvalue)
          postvalue["ruleId"]=this.alertvarservice.editrequested.value?.ruleId
          // postvalue["activate_rule"]=this.alertvarservice.editrequested.value.activate_rule
          postvalue["activate_rule"]=this.activate.value
          postvalue["retroactive"]=this.retroactive.value
          // postvalue["retroactive"]=this.alertvarservice.editrequested.value.retroactive
          postvalue["status_change"]=this.alertvarservice.status_change
          postvalue["timeframe"]=this.timeframe.value
          postvalue["stepsize"]=this.stepsize.value

          // console.log("Engine Change Check------->",this.engineCheck(postvalue))

    
        }
        else{
          Object.assign(postvalue, { ruleFor: this.alertId, description: this.ruleName.value, platform: this.platform, type: this.ruleType, name: this.alertName, status: this.postSatusChange(this.activate.value), enginechange: true,activate_rule:this.alertvarservice.ruleForm.value.context.activate,retroactive:this.alertvarservice.ruleForm.value.context.retroactive,status_change:this.alertvarservice.status_change,timeframe:this.timeframe.value,stepsize:this.stepsize.value });
        }
        // if(postvalue?.conditions.length<2){
          // console.log("size less than 2",postvalue)
          // postvalue.conditions.push(this.alertvarservice.defaultElse)
        
        // }


        // Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key=>{
        //   if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions){
        //     if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions==""){
        //       console.log("Inside Nested If")
        //       postvalue.conditions.splice(parseInt(key),1)
        //       postvalue.conditions.push(this.alertvarservice.defaultElseIf)
        //     }
        //   }
        //   else{
        //     console.log("Inside Else")
        //     postvalue.conditions.splice(parseInt(key),1)
        //     postvalue.conditions.push(this.alertvarservice.defaultElse)
            
        //   }
        // })

        // Object.keys(this.alertvarservice.autoInvestigate.getRawValue().conditions).forEach(key=>{
        //   if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions){
        //     if(this.alertvarservice.autoInvestigate.getRawValue().conditions[key].actions==""){
        //       console.log("Inside Nested If")
        //       postvalue.conditions.push(this.alertvarservice.defaultElseIf)
        //     }
        //   }
        //   else{
        //     postvalue.conditions.push(this.alertvarservice.defaultElse)
            
        //   }
        // })




    
        // postvalue["ruleFor"]=this.alertId
        // postvalue["description"]=this.description
        // postvalue["platform"]=this.platform
        // postvalue["type"]=this.ruleType
        // postvalue["name"]=this.alertName
        // postvalue["status"]=1
        // postvalue["enginechange"]=false
//console.log("PostValue",postvalue)
//console.log("RawValue",this.alertvarservice.autoInvestigate.getRawValue())

      Object.keys(postvalue.conditions).forEach(key=>{
        if(postvalue.conditions[key].actions?.condition!="else"){
//console.log("not on else",postvalue.conditions[key])
          if(postvalue.conditions[key].actions?.action!="no_action_required"){
//console.log("Not on No Action Required",postvalue.conditions[key])
            if(postvalue.conditions[key].actions?.state){
              this.alertvarservice.actionEmpty=false
              this.alertvarservice.showActionError=false
//console.log("Not Empty")
            }
            else{
              this.alertvarservice.actionEmpty=true
              this.alertvarservice.showActionError=true
//console.log("Is Empty")
              if(this.alertvarservice.ActionErrorText.length>0){
                this.alertvarservice.ActionErrorText=",",[key]
              }
              else{
                this.alertvarservice.ActionErrorText=key
              }
            }
            }
            else{
              this.alertvarservice.actionEmpty=false
              this.alertvarservice.showActionError=false
            }
          }
        
      })
console.log("PostValue12",postvalue)

    
    
    
    //Post 
    if(this.alertvarservice.actionEmpty){
      // this.alertvarservice.showError=true
      this.alertvarservice.showActionError=true
      // console.log("Query Not Verified")
    }else{
      if(this.alertvarservice.autoInvestigate.valid){
      
//console.log("<-----------------PostAlert---------------->")
          if(this.alertvarservice.editState){
            await this.alertservice.posteditrule.postrequest(postvalue)
            .then((dat: any) => {
//console.log(dat)
              this.mat_spinner_create_state = false;
              if (dat) {
//console.log("if Dat>>>>>>>>>>>")
                this.open_toaster("success", 'success');
                this.alertservice.providealertdata.emitstate = -1;
                this.cancelClick()
              }else{
//console.log("else Dat>>>>>>>>>>>>")
                this.open_toaster("Failed", 'failure');
              }
            })
            .catch(error => {
//console.log("Catch error>>>>>>>>>>>>",error)
              this.mat_spinner_create_state = false;
              this.open_toaster("Failed", 'failure')
            })
          }
          else{
          await this.alertservice.postnewrule.postrequest(postvalue)
          .then((dat: any) => {
//console.log(dat)
            this.mat_spinner_create_state = false;
            if (dat) {
//console.log("if Dat>>>>>>>>>>>")
              this.open_toaster("success", 'success');
              this.alertservice.providealertdata.emitstate = -1;
              this.cancelClick()
            }else{
//console.log("else Dat>>>>>>>>>>>>")
              this.open_toaster("Failed", 'failure');
            }
            this.cancelClick();
          })
          .catch(error => {
//console.log("Catch error>>>>>>>>>>>>",error)
            this.mat_spinner_create_state = false;
            this.open_toaster("Failed", 'failure')
          })
        }
      }
      else{
        this.alertvarservice.showActionError=true
      }
    }
  }
  

   
 

   



    // postvalue['add_tags']=postvalue.conditions
    // console.log(this.alertvarservice.autoInvestigate.getRawValue())
    // console.log("RuleEditor",this.alertvarservice.ruleConditionEditor)
    // console.log("Engine Query",this.alertvarservice.toengineQuery(this.alertvarservice.autoInvestigate.getRawValue()[0],this.querytokenprovider.parseTokens(this.alertvarservice.ruleConditionEditor).searchTokens))
  }
  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  }

  ngOnDestroy(){
    this.alertvarservice.timeError=false
    this.alertvarservice.status_change=false
    this.alertvarservice.editState=false
    this.alertvarservice.editrequested.state=false
    this.alertvarservice.editrequested.value=null
    this.alertvarservice.queryVerified=false
    this.alertvarservice.postError=true
    this.alertvarservice.showError=false
    // this.alertvarservice.resetAutoInvestigate()
    this.alertvarservice.autoInvestigate=this.alertvarservice.defaultAutoInvestigate
//console.log(this.alertvarservice.autoInvestigate)
    this.alertvarservice.resetRuleForm()
    this.alertvarservice.resetAutoInvestigate()
    this.alertvarservice.actionWindow=''
    this.alertvarservice.stateWindow=''
    // this.alertvarservice.resetAutoInvestigate()
    this.alertvarservice.autoInvestigate=this.alertvarservice.defaultAutoInvestigate
    this.queryEditorService.set_editor_value(this.alertvarservice.ruleConditionEditor,'')
    this.$destroy.next(true);
    this.rcrumpService.route_crumps.length = 2;
    this.alertvarservice.closureAction1={}
    

  }



  // addCond(i:number){
  //   let newcond={"cond":"else_if","index":i+1,"optional":false,"value":{}}
  //   this.alertvarservice.autoInvList.splice(i+1,0,newcond)
    // this.alertvarservice.addFilterCondition(i)
    
  // }
  // removeCond(cond:any){
  //   console.log("Condition",cond)

  // }
  

}

